// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__drivesIcon--DyY4M {
  fill: #fff;
  margin-right: 0.25rem;
}
.style__logo--XKe8w {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
}
.style__menuIcon--kKD0I {
  color: #18191b;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
}
.style__navigationContainer--w8OQS {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  padding: 0.75rem;
  position: relative;
}
.style__navigationContainer--w8OQS > div {
  width: 100%;
}
.style__navigationList--MtBHA {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.style__sideBar--boFzE {
  height: 100vh;
  display: flex;
  flex-direction: column;
  transition: all ease-in-out 0.5s;
  width: 88px;
}
.style__sideBar--boFzE .style__sideBarItem--q63JO {
  display: none;
  width: 100%;
}
.style__sideBar--boFzE .style__sideBarDivider--l68nE {
  width: 1.5rem;
}
.style__sideBar--boFzE .style__navigationList--MtBHA, .style__sideBar--boFzE .style__navigationContainer--w8OQS {
  align-items: center;
}
.style__sideBarContainer--zyCCc {
  display: flex;
  height: 100%;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}
.style__sideBarOpen--HT0Ym {
  transition: all ease-in-out 0.5s;
  width: 16rem;
}
.style__sideBarOpen--HT0Ym .style__sideBarItem--q63JO {
  justify-content: space-between;
  display: flex;
  width: 100%;
}
.style__sideBarOpen--HT0Ym .style__sideBarDivider--l68nE {
  width: 100%;
}
.style__sideBarOpen--HT0Ym .style__navigationList--MtBHA, .style__sideBarOpen--HT0Ym .style__navigationContainer--w8OQS {
  align-items: start;
}
.style__sideBarOpen--HT0Ym .style__sideBarItemButton--HpzWT {
  display: flex;
  justify-content: center;
  width: 100%;
}
.style__sideBarItemButton--HpzWT:hover, .style__sideBarItemButton--HpzWT:focus, .style__sideBarItemButton--HpzWT:active {
  background-color: #e5f9ff !important;
  border-radius: 8px !important;
  color: #0c0d0d;
}
.style__sideBarItemButton--HpzWT:hover span, .style__sideBarItemButton--HpzWT:focus span, .style__sideBarItemButton--HpzWT:active span {
  color: #04AFF9;
}
.style__sideBarItemButton--HpzWT:active {
  background-color: rgba(4, 175, 249, 0.16) !important;
}
.style__sideBarItemButton--HpzWT {
  height: 56px;
  justify-content: center !important;
}
.style__sideBarItemButton--HpzWT:hover .style__sideBarItem--q63JO {
  color: #04AFF9;
}
.style__sideBarItemButton--HpzWT > div {
  display: flex;
  width: 100%;
  gap: 1rem;
  color: #62656a;
  justify-content: center;
}
.style__sideBarItem--q63JO {
  display: flex;
  align-items: center;
  line-height: 1.5rem;
  margin: 0.125rem 0;
  justify-content: flex-start;
}
.style__sideBarItemSelected--W72QL {
  background-color: #e5f9ff !important;
  border-radius: 8px !important;
}
.style__sideBarItemSelected--W72QL > div {
  color: #04AFF9 !important;
}
.style__bottomDSAdmin--e1CW3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10px;
  gap: 2rem;
  position: absolute;
  bottom: 1rem;
}
.style__bottomLink--Z4dPd {
  display: flex;
  justify-content: center;
}
.style__badge--sHFSt {
  background-color: #1aa6da;
  color: #fff;
  border-radius: 50%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.style__subItems--wkKNz {
  width: 100%;
}
.style__subItems--wkKNz > div > div {
  margin-left: 80px;
}
`, "",{"version":3,"sources":["webpack://./../components/src/SideNavigation/style.less"],"names":[],"mappings":"AAGA;EAEI,UAAA;EACA,qBAAA;AAHJ;AAAA;EAOI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;AAJJ;AANA;EAcI,cAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;AALJ;AAdA;EAuBI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,kBAAA;AANJ;AAtBA;EA+BM,WAAA;AANN;AAzBA;EAoCI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;AARJ;AA/BA;EA2CI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,gCAAA;EACA,WAAA;AATJ;AAtCA;EAkDM,aAAA;EACA,WAAA;AATN;AA1CA;EAuDM,aAAA;AAVN;AA7CA;EA4DM,mBAAA;AAXN;AAjDA;EAiEI,aAAA;EACA,YAAA;EACA,2CAAA;AAbJ;AAtDA;EAuEI,gCAAA;EACA,YAAA;AAdJ;AA1DA;EA2EM,8BAAA;EACA,aAAA;EACA,WAAA;AAdN;AA/DA;EAiFM,WAAA;AAfN;AAlEA;EAsFM,kBAAA;AAhBN;AAtEA;EA0FM,aAAA;EACA,uBAAA;EACA,WAAA;AAjBN;AA3EA;EAmGI,oCAAA;EACA,6BAAA;EACA,cAAA;AAnBJ;AAlFA;EAwGM,cAAA;AAjBN;AAvFA;EA6GI,oDAAA;AAnBJ;AA1FA;EAiHI,YAAA;EACA,kCAAA;AApBJ;AAsBI;EAEI,cAAA;AArBR;AAjGA;EA2HM,aAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;EACA,uBAAA;AAvBN;AAxGA;EAoII,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AAzBJ;AA/GA;EA4II,oCAAA;EACA,6BAAA;AA1BJ;AAnHA;EA+IM,yBAAA;AAzBN;AAtHA;EAoJI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;AA3BJ;AA/HA;EA8JI,aAAA;EACA,uBAAA;AA5BJ;AAnIA;EAmKI,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7BJ;AA7IA;EA8KI,WAAA;AA9BJ;AAhJA;EAiLM,iBAAA;AA9BN","sourcesContent":["@import '../colors';\n@import '../spacing';\n\n:local {\n  .drivesIcon {\n    fill: @color-white;\n    margin-right: @spacing-25;\n  }\n\n  .logo {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: @spacing-150;\n  }\n\n  .menuIcon {\n    color: @color-asphalt-grey-010;\n    cursor: pointer;\n    display: flex;\n    flex-shrink: 0;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .navigationContainer {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n    padding: @spacing-75;\n    position: relative;\n\n    > div {\n      width: 100%;\n    }\n  }\n\n  .navigationList {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n  }\n\n  .sideBar {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    transition: all ease-in-out 0.5s;\n    width: 88px;\n\n    .sideBarItem {\n      display: none;\n      width: 100%;\n    }\n\n    .sideBarDivider {\n      width: @spacing-150;\n    }\n\n    .navigationList,\n    .navigationContainer {\n      align-items: center;\n    }\n  }\n\n  .sideBarContainer {\n    display: flex;\n    height: 100%;\n    border-right: 1px solid rgba(0, 0, 0, 0.12);\n  }\n\n  .sideBarOpen {\n    transition: all ease-in-out 0.5s;\n    width: 16rem;\n\n    .sideBarItem {\n      justify-content: space-between;\n      display: flex;\n      width: 100%;\n    }\n\n    .sideBarDivider {\n      width: 100%;\n    }\n\n    .navigationList,\n    .navigationContainer {\n      align-items: start;\n    }\n\n    .sideBarItemButton {\n      display: flex;\n      justify-content: center;\n      width: 100%;\n    }\n  }\n\n  .sideBarItemButton:hover,\n  .sideBarItemButton:focus,\n  .sideBarItemButton:active {\n    background-color: @color-light-blue-099 !important;\n    border-radius: 8px !important;\n    color: @color-asphalt-grey-005;\n\n    span {\n      color: @color-light-blue-neon;\n    }\n  }\n\n  .sideBarItemButton:active {\n    background-color: fade(@color-light-blue-neon, 16%) !important;\n  }\n\n  .sideBarItemButton {\n    height: 56px;\n    justify-content: center !important;\n\n    &:hover {\n      .sideBarItem {\n        color: @color-light-blue-neon;\n      }\n    }\n\n    > div {\n      display: flex;\n      width: 100%;\n      gap: @spacing-100;\n      color: @color-asphalt-grey-040;\n      justify-content: center;\n    }\n  }\n\n  .sideBarItem {\n    display: flex;\n    align-items: center;\n    line-height: @spacing-150;\n    margin: @spacing-15 0;\n    justify-content: flex-start;\n  }\n\n  .sideBarItemSelected {\n    background-color: @color-light-blue-099 !important;\n    border-radius: 8px !important;\n    > div {\n      color: @color-light-blue-neon !important;\n    }\n  }\n\n  .bottomDSAdmin {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 0 10px;\n    gap: @spacing-200;\n    position: absolute;\n    bottom: @spacing-100;\n  }\n\n  .bottomLink {\n    display: flex;\n    justify-content: center;\n  }\n\n  .badge {\n    background-color: @color-light-blue-060;\n    color: @color-white;\n    border-radius: 50%;\n    width: @spacing-200;\n    height: @spacing-200;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .subItems {\n    width: 100%;\n\n    > div > div {\n      margin-left: 80px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drivesIcon": `style__drivesIcon--DyY4M`,
	"logo": `style__logo--XKe8w`,
	"menuIcon": `style__menuIcon--kKD0I`,
	"navigationContainer": `style__navigationContainer--w8OQS`,
	"navigationList": `style__navigationList--MtBHA`,
	"sideBar": `style__sideBar--boFzE`,
	"sideBarItem": `style__sideBarItem--q63JO`,
	"sideBarDivider": `style__sideBarDivider--l68nE`,
	"sideBarContainer": `style__sideBarContainer--zyCCc`,
	"sideBarOpen": `style__sideBarOpen--HT0Ym`,
	"sideBarItemButton": `style__sideBarItemButton--HpzWT`,
	"sideBarItemSelected": `style__sideBarItemSelected--W72QL`,
	"bottomDSAdmin": `style__bottomDSAdmin--e1CW3`,
	"bottomLink": `style__bottomLink--Z4dPd`,
	"badge": `style__badge--sHFSt`,
	"subItems": `style__subItems--wkKNz`
};
export default ___CSS_LOADER_EXPORT___;
